import { QUERIES_KEYS } from "queries";
import { useQuery, useQueryClient, keepPreviousData } from "@tanstack/react-query";
import { discountsApi } from "./discountsApi";

export const useDiscountRegistrations = (paymentDiscountId: number) => {
  const queryClient = useQueryClient();
  const { isLoading, isFetching, data } = useQuery({
    queryKey: QUERIES_KEYS.DISCOUNT_REGISTRATIONS(paymentDiscountId),
    queryFn: () => discountsApi.fetchRegistrations(paymentDiscountId),
    placeholderData: keepPreviousData,
  });

  const invalidate = () => {
    queryClient.invalidateQueries({
      queryKey: QUERIES_KEYS.DISCOUNT_REGISTRATIONS(paymentDiscountId),
    });
  };

  return { invalidate, isLoading, isFetching, registrations: data?.data ?? [] };
};
